import { render, staticRenderFns } from "./appDateProvider.vue?vue&type=template&id=5783d625"
import script from "./appDateProvider.vue?vue&type=script&lang=js"
export * from "./appDateProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports